import Tabs from "../tabs";
import { useSelector } from "react-redux";
import CircularLoader from "../../../../components/loaders/circularLoader";
import { Box, Dialog, DialogContent } from "@mui/material";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import { useState, useEffect } from "react";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import AddBusinessOutlinedIcon from "@mui/icons-material/AddBusinessOutlined";
import NameCardList from "../nameCardList";
import { BranchCreateForm } from "./branchCreation";
import { qrDialogPaperSx, QrModalHeader } from "../../../qrCode/components/qrUi";

export default function BranchList() {
  const { branches, status, error } = useSelector((state) => state.general);

  const [search, setSearch] = useState("");
  const [createOpen, setCreateOpen] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (status === "failed") {
      setSnackbar({
        open: true,
        message: error,
        severity: "error",
      });
    }
  }, [status, error]);

  // Same filter as before
  const filteredBranches = status !== "succeeded" ? [] : branches.filter((item) => item.branch_name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <Tabs onCreate={() => setCreateOpen(true)}>
        <Box>
          {/* Loader */}
          {status === "loading" && (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularLoader color="success" />
            </Box>
          )}

          {/* Success */}
          {status === "succeeded" && (
            <NameCardList
              items={filteredBranches}
              getName={(item) => item.branch_name}
              getId={(item) => item.id}
              search={search}
              onSearchChange={(value) => {
                // no leading space (same rule as before)
                if (!value.startsWith(" ")) {
                  setSearch(value)
                }
              }}
              searchPlaceholder="Search Branch"
              countIcon={<AccountTreeOutlinedIcon />}
              countLabel="branch"
              countLabelPlural="branches"
              watermark={<AccountTreeOutlinedIcon />}
            />
          )}
        </Box>
      </Tabs>

      {/* Create branch popup */}
      <Dialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{ sx: { ...qrDialogPaperSx, maxWidth: { sm: 460 } } }}
      >
        <QrModalHeader
          icon={<AddBusinessOutlinedIcon />}
          title="Create Branch"
          subtitle="Add a new branch"
          onClose={() => setCreateOpen(false)}
        />
        <DialogContent sx={{ p: 0 }}>
          {/* remounts on each open, so the form starts empty */}
          {createOpen && (
            <BranchCreateForm
              embedded
              onCancel={() => setCreateOpen(false)}
              onSuccess={(message) => {
                setCreateOpen(false);
                setSnackbar({ open: true, message: message || "Branch created", severity: "success" });
              }}
            />
          )}
        </DialogContent>
      </Dialog>

      <SnackbarMessage open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} />
    </div>
  );
}
